
function makeAppConfig() {
  const date = new Date();
  const year = date.getFullYear();

  var GA_MK_version = "1.1.8";

  const AppConfig = {

    salesKey : "123",

    // TODO: local urls
    //imagesBaseUrl: "https://anydatapoint.net/",
    imagesBaseUrl: "http://dev.cdn01.anydatapoint.com",
    brandingFolder:"branding", 

    /* ****************************************************************************
     *                                                                            *
     *    Set Following Variable for the LOCAL, DEV and COMMERCIAL environment    *
     *                      0                                                      *
     * ****************************************************************************/

    ENVIRONMENT:"DEV", //Possible-Values ['LOCAL', 'DEV', 'COMMERCIAL']
   // SERVER_REGION:'', //Possible-Values ['PK', 'NA',]

    /*URL Set For Local Environment*/
    // LOCAL_DTAPI_PK:"http://localhost:8089/api/v1",
    // LOCAL_RTAPI_PK:"http://dev.rtapi.jazzba.io/api/v2",
    //
    // LOCAL_DTAPI_NA:"http://localhost:8089/api/v1",
    // LOCAL_RTAPI_NA:"http://dev.rtapi.jazzba.io/api/v2",

    // LOCAL_RA_SERVICE:"http://localhost:8089/api/v1",
    LOCAL_RA_SERVICE:"http://dev.raservice.jazzba.io/",

   // LOCAL_RA_SERVICE:"http://localhost:8089/api/v1",
    //LOCAL_RA_SERVICE:"http://dev.raservice.jazzba.io/",


    /*URL Set For DEV Environment*/
    // DEV_DTAPI_PK:"http://dev.dtapipk.jazzba.io/api/v1",
    // DEV_RTAPI_PK:"http://dev.rtapipk.jazzba.io/api/v2",
    //
    // DEV_DTAPI_NA:"http://dev.dtapi.jazzba.io/api/v1",
    // DEV_RTAPI_NA:"http://dev.rtapi.jazzba.io/api/v2",

    DEV_RA_SERVICE:"http://dev.raservice.jazzba.io/",


    /*URL Set For COMMERCIAL Environment*/
    // COMMERCIAL_DTAPI_PK:"https://dtapipk.jazzba.io/api/v1",
    // COMMERCIAL_RTAPI_PK:"https://rtapipk.jazzba.io/api/v2",
    //
    // COMMERCIAL_DTAPI_NA:"https://dtapina.jazzba.io/api/v1",
    // COMMERCIAL_RTAPI_NA:"https://rtapina.jazzba.io/api/v2",

    COMMERCIAL_RA_SERVICE:"https://raservice.jazzba.io/",





    // RUNTIME_API_PK: "http://dev.dtapipk.jazzba.io/api/v1",
        // RUNTIME_API_NA: "https://dev.dtapina.jazzba.io/api/v1",
        // RA_SERVICE_API: "http://raservice.jazzba.io/",

        // RUNTIME_API_PK: "http://localhost:8089/api/v1",
        // RUNTIME_API_NA: "http://localhost:8089/api/v1",
        RA_SERVICE_API: "http://raservice.jazzba.io/",
        // LOCAL_ApiURL_billing: "http://dev.adppay.jazzba.io/api/v1",     //todo  Billing URLS are no more needed as these are also received from RAService Upon Login
        // DEV_ApiURL_billing: "http://dev.adppay.jazzba.io/api/v1",
        // COMMERCIAL_ApiURL_billing: "http://adppay.jazzba.io/api/v1",
     
    // DEV_NA_imageUploderURL:'http://dev.imageuploaderna.jazzba.io/upload.php',
    // DEV_PK_imageUploderURL:'http://dev.imageuploaderpk.jazzba.io/upload.php',
    //
    // DEV_PK_imageStatsURL:'http://dev.imageuploaderpk.jazzba.io/imagecheck.php',
    // DEV_NA_imageStatsURL:'http://dev.imageuploaderna.jazzba.io/imagecheck.php',
    //
    // COMMERCIAL_NA_imageUploderURL:'https://imageuploaderna.jazzba.io/upload.php',
    // COMMERCIAL_PK_imageUploderURL:'https://imageuploaderpk.jazzba.io/upload.php',
    //
    // COMMERCIAL_PK_imageStatsURL:'https://imageuploaderpk.jazzba.io/imagecheck.php',
    // COMMERCIAL_NA_imageStatsURL:'https://imageuploaderna.jazzba.io/imagecheck.php',
    //
    // LOCAL_NA_imageUploderURL:'http://dev.imageuploaderna.jazzba.io/upload.php',
    // LOCAL_PK_imageUploderURL:'http://dev.imageuploaderna.jazzba.io/upload.php',
    //
    // LOCAL_PK_imageStatsURL:'http://dev.imageuploaderpk.jazzba.io/imagecheck.php',
    // LOCAL_NA_imageStatsURL:'http://dev.imageuploaderna.jazzba.io/imagecheck.php',

    //imageUploderURL:"http://adp-imageuploader.anydatapoint.com/upload.php",
    //imageStatsURL:"http://adp-imageuploader.anydatapoint.com/imagecheck.php",


    //ApiURL: "http://dev.dtapi.jazzba.io/api/v1", 
    //  ApiURL: "http://localhost:8089/api/v1",
    // ApiURL_billing: "http://69.64.55.113:6010/ADPPAYServer/api/v1",
    // ApiURL_billing: "http://dev.adppay.anydatapoint.com/ADPPAYServer/api/v1",

    // ApiURL_billing: "http://dev.adppay.anydatapoint.com/api/v1",
      // todo  May 28 2019  by NH AR and NR
      //  On login the response object will bring the end points [rtapi,dtapi,billingapi] that needs to set for url  of user
    ApiURL_billing: "http://dev.adppay.jazzba.io/api/v1",
    ApiURL_dt: "http://dev.dtapi.jazzba.io/api/v1",
    // java_image_uploader_url : "http://localhost:8087/api/v1",
    java_image_uploader_url : "http://dev.imageuploaderca.jazzba.io/api/v1",
    Monthly_License_alias:"ims",
    webStore_License_alias:"ws",
    WebStore_License_price:500,
    InventoryManagement_License_price:500,
    EDI_Integrations_License_price:0.6,
    EDI_Integrations_License_alias:"integrations-edi",
    chargebeeSiteName:"jazzba-test",
    chargebeeSiteApiKKey:"test_0cuwA2FnHWUS4ALkB9DitT8RByMre8ZFe",
   // ApiURL_billing: "localhost:8080/api/v1",


    // ADP_API_BASE_URL : "http://dev.rtapi.jazzba.io/api/v2",
    prefix : "local",


//Todo we want api  route grouping based on module[e.g intellicommerce intellistock, intellicatalog]?, version?, region, application server URLs
    // jazzba global scripts ++zopim

    zopim_subdomain: 'whiztec.zendesk.com',

    //TODO: Dev urls
    // imagesBaseUrl:"https://anydatapoint.net",
    // brandingFolder:"branding",
    // imageUploderURL:"http://69.64.55.113:88/adp-imageuploader/upload.php",
    // imageStatsURL:"http://69.64.55.113:88/adp-imageuploader/imagecheck.php",
    // ApiURL:"http://dev.manageapi.jazzba.io/api/v1",
    // ApiURL:"http://localhost:8089/api/v1",
    // ADP_API_BASE_URL:"http://dev.adp-server.anydatapoint.com/api/v2",
    // prefix : "dev",

    // imagesBaseUrl:"https://anydatapoint.net",
    // brandingFolder:"branding",
    // imageUploderURL:"http://adp-imageuploader.anydatapoint.com/upload.php",
    // imageStatsURL:"http://adp-imageuploader.anydatapoint.com/imagecheck.php",
    // ApiURL:"http://manageapi.jazzba.io/api/v1",
    // ADP_API_BASE_URL:"https://adp-server.anydatapoint.com/api/v2",
    // prefix : "comm",

    // storeURL : "https://intellicommerce.anydatapoint.com/?custId=",
    storeURL:"http://dev.intellicommerce.jazzba.io/?custId=",

    imageCutterSizes : "80x80,400x400",


    brand: 'Jazzba Inc.', // 'Material' old
    version:"2.5.216",

    user: 'Lisa',
    year,
    layoutBoxed: false,               // true, false
    navCollapsed: false,              // true, false
    navBehind: false,                 // true, false
    fixedHeader: false,                // true, false
    sidebarWidth: 'middle',           // small, middle, large
    theme: 'light',                   // light, gray, dark
    colorOption: '11',                // 11,12,13,14,15,16; 21,22,23,24,25,26; 31,32,33,34,35,36
    AutoCloseMobileNav: true,         // true, false. Automatically close sidenav on route change (Mobile only)
    productLink: '#'
    // productLink: 'https://themeforest.net/item/material-design-angular-2-admin-web-app-with-bootstrap-4/19421267'
  };

  return AppConfig;
}

export const APPCONFIG = makeAppConfig();



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/config.ts